import domReady from '@wordpress/dom-ready';
import manifest from './../manifest.json';

domReady(async () => {
	const languageSwitcherSelector = `.${manifest.componentJsClass}-desktop`;
	const languageSwitcherMenuSelector = `.${manifest.componentJsClass}-desktop-menu`;
	const languageSwitcher = document.querySelector(languageSwitcherSelector);
	const languageSwitcherMenu = languageSwitcher?.querySelector(languageSwitcherMenuSelector);

	if (!languageSwitcher || !languageSwitcherMenu) {
		return;
	}

	languageSwitcher.addEventListener('mouseenter', () => {
		languageSwitcherMenu.removeAttribute('aria-hidden');
	});

	languageSwitcher.addEventListener('mouseleave', () => {
		languageSwitcherMenu.setAttribute('aria-hidden', 'true');
	});

	languageSwitcher.addEventListener('focusin', () => {
		languageSwitcherMenu.removeAttribute('aria-hidden');
	});

	languageSwitcher.addEventListener('focusout', (event) => {
		if (!languageSwitcher.contains(event.relatedTarget)) {
			languageSwitcherMenu.setAttribute('aria-hidden', 'true');
		}
	});
});
